<template>
  <div class="forma-pagamento">
    <b-card>
      <b-card-header>
        <b-card-title>Forma de Pagamento</b-card-title>
      </b-card-header>
      <b-card-body>
        <p class="text-muted">
          Gerencie suas formas de pagamento.
        </p>
        <!-- Conteúdo das formas de pagamento será implementado aqui -->
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody,
} from 'bootstrap-vue'

export default {
  name: 'FormaPagamento',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
  },
}
</script>
